import { useCallback } from 'react';
import AdCampaignModel from "../models/ads.campaign.model";
import { AdCampaignType } from "../types/ads.campaign";
import { useReducerAsState } from "./useReducerAsState";

interface State {
    loading: boolean;
    error: string | null;
    campaign: AdCampaignType | null;
}

const useAdCampaign = () => {
    const [state, setState] = useReducerAsState<State>({
        loading: false,
        error: null,
        campaign: null,
    });

    const { loading, error, campaign } = state;

    const loadAdCampaign = useCallback(async (adCampaignId: number) => {
        setState({
            loading: true,
            error: null,
            campaign: null,
        });

        const response = await AdCampaignModel.find(adCampaignId);

        if (response.error) {
            setState({
                loading: false,
                error: response.error,
                campaign: null,
            });
            return;
        } 

        setState({
            loading: false,
            error: null,
            campaign: response.adsCampaign?.data[0],
        });
    }, [setState]);

    const saveAdCampaign = useCallback(async (data: AdCampaignType): Promise<boolean> => {
        setState({
            loading: true,
            error: null,
        });

        const response = await AdCampaignModel.saveAd(data);

        if (response.error) {
            setState({
                loading: false,
                error: response.error,
            });
            return false;
        } 

        setState({
            loading: false,
            error: null,
        });

        return true;
    }, [setState]);

    return {
        loading,
        error,
        campaign,
        loadAdCampaign,
        saveAdCampaign,
    }
}

export default useAdCampaign;